import json from './sprite.js';

export default {
    handle: 'en_SPT12-Candy-Jar',
    label: 'en_SPT12-Candy-Jar',
    json,
};
